import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'lazysizes';
import './Main.scss';
import '../Navigation/Navigation';
import '../Footer/Footer.scss';
import { initFavorite } from '../helpers/favorites';
import Impressions from '../helpers/impressions';
import CardAnalytics from '../helpers/cardAnalytics';
import { loadChunk } from '../helpers/load-chunk';
import { initAnalytics } from '../helpers/analytics';
import Questionary from '../Questionary/Questionary';
import Countdown from '../Countdown/Countdown';
import Footer from '../Footer/Footer';
import { initToggleChips } from '../UiKit/Elements/ToggleChip/ToggleChip';
import oneTapLogin from '../helpers/one-tap-login';
import '../LanguagePopup/LanguagePopup';
import { setupHotkeys } from './setup-hotkeys';
import { sendMapboxSupportedEvent } from '../helpers/mapbox-supported';
import handleTelegramSupportClick from '../helpers/handleTelegramSupportClick';
import CurrencySwitcher from '../UiKit/Blocks/CurrencySwitcher/CurrencySwitcher';
import '../MomentOfSilence/MomentOfSilence';

const initMain = async () => {
  if (process.env.NODE_ENV === 'production' && window.isBrowserSupported) {
    await loadChunk(() => import(/* webpackChunkName: "Loggers" */ '../Loggers/Loggers'));
  }

  initFavorite();
  window.impressions = new Impressions();
  window.cardAnalytics = new CardAnalytics();
  initAnalytics();
  Questionary();
  Countdown();
  window.initCountdown = Countdown;
  new CurrencySwitcher();

  Footer();
  initToggleChips();
  oneTapLogin();
  setupHotkeys();
  sendMapboxSupportedEvent();
  handleTelegramSupportClick();
};

initMain();
